var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 25,
    viewBox: "0 0 21 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.22003 19.86H11.78V14.42H9.22003V19.86ZM0.676025 24.98H20.324V9.30002H17.764V7.12402C17.764 3.15602 14.436 0.0200195 10.5 0.0200195C6.56402 0.0200195 3.23603 3.15602 3.23603 7.12402V9.30002H0.676025V24.98ZM3.23603 22.58V11.7H17.764V22.58H3.23603ZM5.79603 9.30002V7.12402C5.79603 4.56402 7.90802 2.42002 10.5 2.42002C13.092 2.42002 15.204 4.56402 15.204 7.12402V9.30002H5.79603Z",
    fill: "#E6E0FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.e2e7d6a438e356f79efebb03b24b24df.svg";
export { ForwardRef as ReactComponent };